module.exports = __webpack_public_path__ + "static/media/background.d5d80090.png";